// const crypto = require("crypto");
import CryptoJS from "crypto-js";
const CONSTANT = require("./constants");
// const CIPHER_ALGO = "aes-128-cbc"; //"bf-ecb"
//const iv = "";
const SECRET_KEY = CONSTANT.SETTING.CRYPTO_KEY;
const IV = CryptoJS.enc.Utf8.parse("0000000000000000"); // 16 bytes

// module.exports.encode = text => {
//   var cipher = crypto.createCipher(CIPHER_ALGO, CONSTANT.SETTING.CRYPTO_KEY);
//   var crypted = cipher.update("" + text, "utf8", "hex");
//   crypted += cipher.final("hex");
//   return crypted;
// };

// module.exports.decode = text => {
//   try {
//     var decipher = crypto.createDecipher(
//       CIPHER_ALGO,
//       CONSTANT.SETTING.CRYPTO_KEY
//     );
//     var dec = decipher.update("" + text, "hex", "utf8");
//     dec += decipher.final("utf8");
//     return dec;
//   } catch (error) {
//     return null;
//   }
// };

const encode = (text) => {

  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(text),
    CryptoJS.enc.Utf8.parse(SECRET_KEY.padEnd(16, "0").slice(0, 16)),
    { iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    // { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
};

const decode = (cipherHex) => {
  try {
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Hex.parse(cipherHex),
    });

    const decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      CryptoJS.enc.Utf8.parse(SECRET_KEY.padEnd(16, "0").slice(0, 16)),
      { iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
      // { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    return null;
  }
};

const CryptoUtils = { encode, decode };
export default CryptoUtils;